module.exports = __webpack_public_path__ + "img/schollerimmobilien.a3cbb8fe.jpg";